import React from 'react';
import { Row } from 'framework7-react';
import PropTypes from 'prop-types';
import withForms from '../formsCommon/withForms';
import withQuickForm from './withQuickForm';

class InlineQuickForm extends React.Component {
  render() {
    const { document, scanEnded, generateForm } = this.props;

    // noinspection CheckTagEmptyBody
    return document ? (
      <Row className={'quickForm inlineQuickForm'}>
        {generateForm(window.isDesktop, 0, scanEnded)}
      </Row>
    ) : (
      <></>
    );
  }
}

InlineQuickForm.propTypes = {
  generateForm: PropTypes.func,

  //withDocumentCommonPropTypes
  scanEnded: PropTypes.bool,
  document: PropTypes.object
};

export default withForms(withQuickForm(InlineQuickForm));
